<template>
  <div class="module_page page_content list_container_v4 institution" aria-label="My Institutions page">

    <div class="row page-heading">
      <div class="col-7 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
      </div>
      <div class="col-5 right-container"></div>
    </div>

    <div class="page_content_container">

      <institution-menu :uuid="uuid" :active="'child'"></institution-menu>

      <div class="row pg_content">
        <div class="col-12">
          <div class="course-management-section folder-management-section">
            <div class="page_subheading">
              <div class="toolbar-right ui-list-toolbar">
                <select v-model="perPage" aria-label="page size" class="page_size">
                  <option v-for="option in pageOptions" v-bind:value="option">
                    {{ option }}
                  </option>
                </select>
                <div class="btn_container pagination_sty3">
                  <b-pagination
                    align="center"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    :limit="1"
                    :hide-goto-end-buttons="true"
                    :label-prev="$t('previousPage')"
                    :label-next="$t('nextPage')">
                    <template #prev-text>
                      <span class="ic2_arr_pre3" aria-hidden="true"></span>
                    </template>
                    <template #next-text>
                      <span class="ic2_arr_next3" aria-hidden="true"></span>
                    </template>
                  </b-pagination>
                </div>
                <div class="search-box-container">
                  <input type="text" class="input-search" v-model="filter" placeholder="search by institution name" aria-label="search by institution name">
                  <button type="button" class="btn btn_srh" aria-label="search institutions">
                    <span class="ic_srh ic_search" aria-hidden="true"></span>
                  </button>
                </div>
              </div>
            </div>
            <b-container fluid>
              <b-row>
                <div class="data_tbl_container course-management-table-container" style="height: calc(100vh - 250px) !important;">
                  <b-table bordered :isRowHeader="true" :head-variant="'light'" :items="institutions" :fields="fields"
                    :current-page="currentPage" :per-page="perPage" :filter="filter" @filtered="onFiltered" class="quick-link-management-table">
                    <template slot="name" slot-scope="data">
                      <div class="row entity_title" :class="addStyleClass(data.item)">
                        <div class="col-2 ic ic-inst"></div>
                        <div class="col-10 txt">
                          {{ data.item.title }}
                        </div>
                      </div>
                    </template>
                    <template slot="parentOpenId" slot-scope="data" v-if="data.item.parentOpenId">
                      <div class="row entity_title">
                        <div class="col-2 ic ic-inst"></div>
                        <div class="col-10 txt">
                          {{ getParentName(data.item.parentOpenId) }}
                        </div>
                      </div>
                    </template>
                    <template slot="uuid" slot-scope="data">
                      <div class="action" :class="addStyleClass(data.item)">
                        <b-btn class="ic ic_btn" @click="changeInstitution(data.item)" :title="$tf('switchTo') + ' ' + data.item.title" v-b-popover.hover>
                          <span class="ic_tab"></span>
                        </b-btn>
                        <template v-if="enableShare(data.item)">
                          <b-btn class="ic ic_btn" @click="openFolderShareModal(data.item)" :title="$tf('shareFolder') + ' ' + data.item.title" v-b-popover.hover>
                            <span class="ic_share2"></span>
                          </b-btn>
                        </template>
                        <template v-else>
                          <b-btn class="ic_btn_dummy" style="width: 42px;">
                          </b-btn>
                        </template>
                      </div>
                    </template>
                  </b-table>
                  <template v-if="shouldShowNoResultFound">
                    <span class="no_result">
                      {{ $tf('noResult') }}
                    </span>
                  </template>
                </div>
              </b-row>
            </b-container>
          </div>
        </div>
      </div>
    </div>

        <div>
        <b-modal class="modal__v22_2" ref="folderShareModal" size="lg" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
          <div slot="modal-header" class="row header-section w-100">
            <div class="col-8 hd_txt" style="margin-left: auto; padding-top: 8px; padding-left: 25px;">
              <span>{{ $tf('shareFolder') }} {{sharingInstitution.title}}  </span>
            </div>
            <div class="col-4 btn_container" style="padding-right: 0px;">
              <button class="btn_close" aria-label="$tf('close')" :title="$tf('closeBtnToolTip')" @click="closeFolderShareModal()">
                <span class="ic-close"></span>
              </button>
            </div>
          </div>

          <div class="modal_flds_container">
            <div class="col-11 sec_content" style="margin: auto;">
              <div class="row fld_row mb-5">
                <div class="col-12 fld_label">
                  {{ $tf('selectFolder') }}
                </div>
                <div class="col-12 fld_input">
                  <autocomplete
                    ref="`autocomplete_user`"
                    :source="folderList"
                    :placeholder="$tf('startTypingPH1')"
                    :aria-label="$tf('startTypingAria1')"
                    input-class="form-control"
                    :results-display="getDynamicSelectFormattedDisplay"
                    @selected="dynamicSelectAfterSelected($event)">
                  </autocomplete>
                </div>
            </div>

            <div class="row">
                <div class="col-12 fld_label">
                  {{ $tf('sharedFolders') }}
                </div>
                <div class="col-12 fld_val">
                  <ul v-for="sharedFolder in sharedFolderList" :key="sharedFolder.uuid" class="sec_content_list">
                    <li class="row">
                      <span class="col-1 ic ic_folder"></span>
                      <span class="col-11 txt">
                        {{sharedFolder.title}}
                      </span>
                    </li>
                  </ul>
                </div>
            </div>

            </div>
          </div>
          <div slot="modal-footer" class="w-100">
            <b-button @click="sharedFolderWithInstitution()" class="btn button-primary float-right mr-2">
              {{ $tf('ok') }}
            </b-button>
            <b-button @click="closeFolderShareModal()" class="btn button-primary float-right mr-2">
              {{ $tf('cancel') }}
            </b-button>
          </div>

        </b-modal>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import InstitutionHeader from './InstitutionHeader'
import Autocomplete from 'vuejs-auto-complete'
export default {
  name: 'ChildInstitutionSwitch',
  props: ['uuid'],
  components: {
    InstitutionMenu,
    InstitutionHeader,
    Autocomplete
  },
  data: () => {
    return {
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [ 10, 50, 100 ],
      filter: '',
      institutions: [],
      folderList : [{uuid:'aaaa', title:'FolderA'}, {uuid:'aaaab', title:'FolderB'}],
      allSharableFolder: [],
      sharedFolderList:[],
      sharingInstitution: {},
      shouldShowNoResultFound: false,
      fields: [
        {key: 'name', label: 'Institution Name', class: 'first-column', thClass: 'text-center'},
        {key: 'parentOpenId', label: 'Parent Institution', class: 'second-column', thClass: 'text-center'},
        {key: 'uuid', label: 'Action', class: 'third-column', thClass: 'text-center'}
      ]
    }
  },
  mounted () {
    this.loadInstitution()
  },
  methods: {
    ...mapActions([
      'loadInstitutionDetail',
      'loadAllUserInstitution',
      'setUserInfo',
      'loadChangeUserInstitution',
      'loadSharableFolders',
      'shareFolders'
    ]),
    loadInstitution () {
      this.loadInstitutionDetail(this.uuid)
      this.populateInstitutions()
    },
    populateInstitutions () {
      this.loadAllUserInstitution().then(resp => {
        this.institutions = resp
        this.totalRows = this.institutions.length
      })
    },
    getParentName(parentOpenId){
        let pName = ''
        $.each(this.institutions, (j, ins) => {
                  if(ins.openId === parentOpenId){
                      pName= ins.title
                  }
              })
        return pName
    },
    enableShare(ins) {
      if(!this.institution.parentOpenId && ins.parentOpenId){
        if(this.uuid !==ins.uuid){
          return true
        }
      }
      return false
    },
    getDynamicSelectFormattedDisplay (item) {
        return item.title || item
    },
    dynamicSelectAfterSelected (item, question, i) {
        this.folderList = this.folderList.filter(val => val.uuid !== item.selectedObject.uuid);
        this.sharedFolderList.push(item.selectedObject)
    },
    closeFolderShareModal(){
      this.sharingInstitution = {}
      this.$refs.folderShareModal.hide()
    },
    sharedFolderWithInstitution () {
      let sharedFolderUuids = []
      for(var i=0;i<this.sharedFolderList.length;i++){
        sharedFolderUuids[i] = this.sharedFolderList[i].uuid
      }
      this.shareFolders({insId:this.sharingInstitution.uuid,sharedFolderUuids:sharedFolderUuids}).then(res => {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Folders successfully shared with Insitution.'
          })
          this.populateInstitutions()
          this.closeFolderShareModal()
      })

    },
    async openFolderShareModal(ins){
      this.folderList = []
      this.sharedFolderList = []
      this.sharingInstitution = ins
      this.allSharableFolder = []
      this.loadSharableFolders().then(res => {
          this.allSharableFolder = []
          $.each(res, (i, fol) => {
            var result = {
              uuid: fol.uuid,
              title: fol.displayName
            }
            this.allSharableFolder.push(result)
            let alreadyShared = false
            if(this.sharingInstitution.parentSharedLibs) {
              $.each(this.sharingInstitution.parentSharedLibs, (j, folder) => {
                  if(folder===fol.uuid){
                      alreadyShared = true
                  }
              })
            }
            if(!alreadyShared){
                this.folderList.push(result)
            }else{
                this.sharedFolderList.push(result)
            }
          })
        this.$refs.folderShareModal.show()
        })
    },
    navigateToDashboard (userRole) {
      let role = userRole.toLowerCase()
      let url = '/user/track/' + role
      if ((role === 'instructor & admin') || (role === 'curator')) {
        url = '/user/track/admin'
      } else if (role === 'employer admin') {
        url = '/employer/admin'
      } else if (role === 'prospective student' || role === 'admitted student') {
        url = '/user/track/' + role.split(' ').join('_')
      } else if (role === 'widget admin') {
        url = '/user/track/' + role.split(' ').join('_')
      }
      this.$router.push(url)
      setTimeout(() => {
        window.location.reload()
      }, 500)
    },
    changeInstitution (institution) {
      this.loadChangeUserInstitution(institution.uuid).then(res => {
        this.$store.commit('LOAD_ALL_CHANNELS', [])
        this.$store.commit('LOAD_LEARNING_SPACES', [])
        let status = res.status
        let userObj = res.data
        if (status === 200) {
          this.setUserInfo(userObj)
          let userRole = userObj.roles[0].role
          let role = userRole.toLowerCase()
          this.navigateToDashboard(role)
        }
      })
    },
    addStyleClass (item) {
      if (this.uuid === item.uuid) {
        return 'current-institution'
      }
      return 'other-institution'
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
      if (filteredItems.length === 0) {
        this.shouldShowNoResultFound = true
      } else {
        this.shouldShowNoResultFound = false
      }
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution
    })
  }
}
</script>

<style>
.current-institution {
  font-weight: bold;
}
.other-institution {

}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/ChildInstitutionSwitch.vue